module.exports = __webpack_public_path__ + "img/p_1.67a21ebc.png";